
import React, { useState, useEffect } from "react";
import { collection, query, where, getDocs, updateDoc } from "firebase/firestore";
import { productDb } from "../firebaseProducts";
import "../CollectionUpdater.css";
const CollectionUpdater = () => {
  const [collectionChoice, setCollectionChoice] = useState(""); // A, C
  const [style, setStyle] = useState("");
  const [colors, setColors] = useState([]);
  const [sizes, setSizes] = useState([]);
  const [selectedColor, setSelectedColor] = useState("");
  const [selectedSize, setSelectedSize] = useState("");
  const [price, setPrice] = useState("");
  const [salePrice, setSalePrice] = useState("");
  const [endSale, setEndSale] = useState("");
  const [loading, setLoading] = useState(false);

  // Map which collections update together
  const collectionMap = {
    A: ["kids-accessories-menu", "full-kids-accessories"],
 B: ["kids-apparel-menu", "kids-apparel","full-kids-white","kids-apparel-white-menu"],
    C: ["adult-accessories-list-menu", "full-adult-accessories"],
     D: ["adult-list-menu", "adult-apparel"],
     E: [  "drinkwear-menu","full-drinkwear"]
  };
  


  // When style changes → fetch available colors & sizes
  useEffect(() => {
    const fetchAttributes = async () => {
      if (!style || !collectionChoice) return;

      const collectionsToCheck = collectionMap[collectionChoice] || [];
      const foundColors = new Set();
      const foundSizes = new Set();

      for (const colName of collectionsToCheck) {
        const q = query(collection(productDb, colName), where("Style", "==", style));
        const snap = await getDocs(q);

        snap.forEach((doc) => {
          const data = doc.data();
          if (data.Color) foundColors.add(data.Color);
          if (data.Size) foundSizes.add(data.Size);
        });
      }

      setColors([...foundColors]);
      setSizes([...foundSizes]);
    };

    fetchAttributes();
  }, [style, collectionChoice]);

  // Handle Update
  const handleUpdate = async () => {
    if (!collectionChoice || !style) {
      alert("Please select collection and style");
      return;
    }

    setLoading(true);

    const collectionsToUpdate = collectionMap[collectionChoice] || [];

    try {
      for (const colName of collectionsToUpdate) {
        const q = query(collection(productDb, colName), where("Style", "==", style));
        const snap = await getDocs(q);

        for (const docSnap of snap.docs) {
          const data = docSnap.data();

          // check color & size match if they exist
          const matchColor = selectedColor ? data.Color === selectedColor : true;
          const matchSize = selectedSize ? data.Size === selectedSize : true;

          if (matchColor && matchSize) {
            const updates = {};
// Price only updates if it's provided
if (price !== "") updates.Price = Number(price);

// Sale price: set to number or NULL
updates.salePrice = salePrice === "" ? null : Number(salePrice);

// End sale: set to value or NULL
updates.endSale = endSale === "" ? null : endSale;

            if (Object.keys(updates).length > 0) {
              await updateDoc(docSnap.ref, updates);
            }
          }
        }
      }

      alert("Products updated successfully!");
    } catch (err) {
      console.error("Update failed", err);
      alert("Error updating products");
    }

    setLoading(false);
  };

  // return (
  //   <div className="p-4 max-w-lg mx-auto bg-gray-100 rounded-lg shadow">
  //     <h2 className="text-xl font-bold mb-4">Product Updater</h2>

  //     {/* Select collection */}
  //     <select
  //       value={collectionChoice}
  //       onChange={(e) => setCollectionChoice(e.target.value)}
  //       className="w-full p-2 border mb-3"
  //     >
  //       <option value="">Select Collection</option>
  //       <option value="A">Kid's Accessories</option>
  //       <option value="B">Kid's Apparel</option>
  //       <option value="C">Adult's Accessories</option>
  //       <option value="D">Adult's Apparel</option>
  //       <option value="E">Drinkwear</option>
  //     </select>

  //     {/* Style input */}
  //     <input
  //       type="text"
  //       placeholder="Enter Style"
  //       value={style}
  //       onChange={(e) => setStyle(e.target.value)}
  //       className="w-full p-2 border mb-3"
  //     />

  //     {/* Color dropdown */}
  //     {colors.length > 0 && (
  //       <select
  //         value={selectedColor}
  //         onChange={(e) => setSelectedColor(e.target.value)}
  //         className="w-full p-2 border mb-3"
  //       >
  //         <option value="">All Colors</option>
  //         {colors.map((c) => (
  //           <option key={c} value={c}>
  //             {c}
  //           </option>
  //         ))}
  //       </select>
  //     )}

  //     {/* Size dropdown */}
  //     {sizes.length > 0 && (
  //       <select
  //         value={selectedSize}
  //         onChange={(e) => setSelectedSize(e.target.value)}
  //         className="w-full p-2 border mb-3"
  //       >
  //         <option value="">All Sizes</option>
  //         {sizes.map((s) => (
  //           <option key={s} value={s}>
  //             {s}
  //           </option>
  //         ))}
  //       </select>
  //     )}

  //     {/* Price fields */}
  //     <label>New Price ($5 will be added Auto)</label>
  //     <input
  //       type="number"
  //       placeholder="New Price (leave blank = no change)"
  //       value={price}
  //       onChange={(e) => setPrice(e.target.value)}
  //       className="w-full p-2 border mb-3"
  //     />
  //      <label>Sale Price</label>
  //     <input
  //       type="number"
  //       placeholder="Sale Price (leave blank = no change)"
  //       value={salePrice}
  //       onChange={(e) => setSalePrice(e.target.value)}
  //       className="w-full p-2 border mb-3"
  //     />
  //      <label>End date</label>
  //     <input
  //       type="date"
  //       value={endSale}
  //       onChange={(e) => setEndSale(e.target.value)}
  //       className="w-full p-2 border mb-3"
  //     />

  //     <button
  //       onClick={handleUpdate}
  //       disabled={loading}
  //       className="w-full bg-blue-500 text-black p-2 rounded disabled:bg-gray-400"
  //     >
  //       {loading ? "Updating..." : "Update"}
  //     </button>
  //   </div>
  // );

  return (
  <div className="updater-page">
    <div className="updater-card">
      <h2>Price Updater</h2>

      <div className="form-group">
        <label>Collection</label>
        <select
          value={collectionChoice}
          onChange={(e) => setCollectionChoice(e.target.value)}
        >
          <option value="">Select Collection</option>
          <option value="A">Kid's Accessories</option>
          <option value="B">Kid's Apparel</option>
          <option value="C">Adult's Accessories</option>
          <option value="D">Adult's Apparel</option>
          <option value="E">Drinkwear</option>
        </select>
      </div>

      <div className="form-group">
        <label>Style</label>
        <input
          type="text"
          placeholder="Ex: WWB-105"
          value={style}
          onChange={(e) => setStyle(e.target.value)}
        />
      </div>

      {colors.length > 0 && (
        <div className="form-group">
          <label>Color</label>
          <select
            value={selectedColor}
            onChange={(e) => setSelectedColor(e.target.value)}
          >
            <option value="">All Colors</option>
            {colors.map((c) => (
              <option key={c} value={c}>
                {c}
              </option>
            ))}
          </select>
        </div>
      )}

      {sizes.length > 0 && (
        <div className="form-group">
          <label>Size</label>
          <select
            value={selectedSize}
            onChange={(e) => setSelectedSize(e.target.value)}
          >
            <option value="">All Sizes</option>
            {sizes.map((s) => (
              <option key={s} value={s}>
                {s}
              </option>
            ))}
          </select>
        </div>
      )}

      <p className="info-text">Main price will auto add $5</p>

      <div className="form-group">
        <label>New Price</label>
        <input
          type="number"
          placeholder="Leave blank = no change"
          value={price}
          onChange={(e) => setPrice(e.target.value)}
        />
      </div>

      <div className="form-group">
        <label>Sale Price</label>
        <input
          type="number"
          placeholder="Blank = remove sale"
          value={salePrice}
          onChange={(e) => setSalePrice(e.target.value)}
        />
      </div>

      <div className="form-group">
        <label>End Sale Date</label>
        <input
          type="date"
          value={endSale}
          onChange={(e) => setEndSale(e.target.value)}
        />
      </div>

      <button
        className="update-btn"
        onClick={handleUpdate}
        disabled={loading}
      >
        {loading ? "Updating..." : "Update Products"}
      </button>
    </div>
  </div>
);

};

export default CollectionUpdater;
